import DAO from './DAO.js';
import supportRequestsService from '../services/supportRequestsService.js';
import dataModel from '../models/DataModel';
import OfflineQueue from './queue/OfflineQueue';
import Metadata from '../helpers/metadata/Metadata';

export default class SupportRequestsDAO extends DAO {

  constructor(store) {
    super(store, 'support_request');
  }

  createSupportRequest(supportRequest, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return supportRequestsService.createSupportRequest(supportRequest, eventMetadatum, options).then(response => {
      return this.handleResponse(response, supportRequest, 'create', eventMetadatum, options, 'Support request submittal');
    })
    .catch((error) => {
      throw error;
    });
  }

  handleResponse(response, supportRequest, activity, eventMetadatum, options, errorMessage) {
    if (response.offline) {
      return this.handleOfflineResponse(supportRequest, activity, eventMetadatum, options);
    }
    else if (response.error) {
      dataModel.displayHTTPError(errorMessage, response.error, false);
      this.throwItemError(); //make sure to send the denormalized attachment
    }
    else {
      return this.normalizeAndSyncToStore(response, { store: false });
    }
  }

  handleOfflineResponse(supportRequest, activity, eventMetadatum, options) {
    OfflineQueue.addQueueItem(this.itemType, activity, { supportRequest, eventMetadatum, options });
    return supportRequest;
  }
  
  completeOfflineUpdate(queueItem) {
    const supportRequest = queueItem.itemInfo.supportRequest;
    const eventMetadatum = queueItem.itemInfo.eventMetadatum;
    const options = queueItem.itemInfo.options;
    switch (queueItem.operationKey) {
    case 'create':
      return this.createSupportRequest(supportRequest, eventMetadatum, options);
    default:
      break;
    }
    return true;
  }

  clearState(options) {
    // nothing to do (yet)
  }
}



// WEBPACK FOOTER //
// ./src/dao/SupportRequestsDAO.js